import {
  createStore,
} from 'vuex';

import { version } from '../../package.json';

export const state = {
  checkboxHomeScreen: [],
  selectBoxCalculationScreen: [],
  desiredIncome: "",
  calculationResult: {},
  dateOfBirth: "",
  inputObj: {},
  formSessionId: ""
};

export const mutations = {
  setCalculationResult(state, value) {
    state.calculationResult = value;
  },
  setcheckboxHomeScreen(state, newValue) {
    state.checkboxHomeScreen = newValue;
  },
  setDesiredIncome(state, value) {
    state.desiredIncome = value;
  },
  setSelectBoxCalculationScreen(state, value) {
    state.selectBoxCalculationScreen = value;
  },
  updateSelectBoxCalculationScreen(state, payload) {
    state.selectBoxCalculationScreen = payload;
  },
  resetSelectBoxCalculationScreen() {
    state.selectBoxCalculationScreen = '';
  },
  resetCalculationResult() {
    state.calculationResult = {};
  },
  resetDesiredIncome() {
    state.desiredIncome = "";
  },
  resetDateOfBirth() {
    state.dateOfBirth = "";
  },
  resetInputObj() {
    state.inputObj = {};
  },
  setInputObj(state, val) {
    state.inputObj = val;
  },
  setFormSessionId(state, value) {
    state.formSessionId = value;
  },
  generateFormSessionId(state) {
    state.formSessionId = Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  },
  setDateOfBirth(state, value) {
    state.dateOfBirth = value;
  },
  resetData(state, stepStage) {
    if (stepStage === 4) {
      mutations.resetCalculationResult();
    } else if (stepStage === 3) {
      mutations.resetCalculationResult();
      mutations.resetDateOfBirth();
      mutations.resetInputObj();
    } else if (stepStage < 3) {
      mutations.resetCalculationResult();
      mutations.resetDateOfBirth();
      mutations.resetInputObj();
      mutations.resetSelectBoxCalculationScreen();
      mutations.resetDesiredIncome();
    }
  },
  getEnvironment(){
    switch(window.location.hostname){
      case 'ofi-d.azure.nl.eu.abnamro.com' : return 'dev';
      case 'ofi-t.azure.nl.eu.abnamro.com' : return 'dev';
      case 'www-et1.abnamro.nl' : return 'dev';
      case 'abnamro.nl' : return 'prod';
      case 'www.abnamro.nl' : return 'prod';
      default: return 'dev';
    }
  },
  setAabAnalyticsGlobal() {
    window.aabAnalyticsGlobal = {
      app_platform: "iframe",
      app_name: window.location.pathname === '/grip/financieelinzicht/eerderstoppenmetwerken/' ? "early retirement - grip" : "early retirement",
      app_environment: mutations.getEnvironment(),
      app_version: version,
      app_organisation: "ABN AMRO",
      app_country_code: "nl",
      app_business_line: "retail",
      app_oar :	"AAB.SYS.016170",
      app_client_unit	:"personal and business banking",
      app_business_segment : "personal",
    }
  }
};

export default createStore({
  state,
  mutations,
  actions: {
  },
  modules: {
  }
})
